import React from 'react';
import { StyleSheet } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import BaseText from '../BaseText';
import Icon from '../Icon';
import RowView from '../RowView';

const WidgetTitle = ({ iconName, label }) => {
  return (
    <RowView style={CommonStyles.centerItems}>
      <Icon name={iconName} style={styles.icon} />
      <BaseText style={CommonStyles.h2}>{label}</BaseText>
    </RowView>
  );
};

const styles = StyleSheet.create({
  icon: {
    fontSize: 24,
    color: Color.gray,
    ...CommonProperties.mr3,
  },
});

export default WidgetTitle;
